import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { v as bvVar } from 'bv';

const descriptionElement = document.querySelector('meta[name="description"]');

const MetaDataView = ({ title, description, prerenderReady }) => {
  useEffect(
    () => {
      if (title) document.title = title;
      if (description) descriptionElement.content = description;
      if (!window.prerenderReady) {
        window.prerenderReady = prerenderReady;
      }
    },
    [title, description, prerenderReady],
  );

  return null;
};

MetaDataView.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  prerenderReady: PropTypes.bool,
};

MetaDataView.defaultProps = {
  title: bvVar('siteName'),
  description: bvVar('siteName'),
  prerenderReady: false,
};

export default MetaDataView;
